import { useQuery } from '@tanstack/react-query';
import { fetchMyNetwork } from '@/api/network';
import type { MyNetworkParams } from '@/api/questionnaires/types';

export function myNetworkQueryKey(params: MyNetworkParams) {
  return ['network', 'my-network', params] as const;
}

export function useMyNetwork(params: MyNetworkParams) {
  return useQuery({
    queryKey: myNetworkQueryKey(params),
    queryFn: () => {
      const qs = new URLSearchParams({
        isSupplierNetwork: 'true',
        page: String(params.page - 1),
        count: String(params.limit),
        filter: params.filter ?? '{}',
        ...(params.sort ? { sort: params.sort } : {}),
      });
      return fetchMyNetwork(qs.toString());
    },
  });
}
